const getLocation = (googleApiResult) =>
  googleApiResult?.results?.[0]?.geometry?.location || {lat: 0, lng: 0};

export default getLocation;
